import { clsx } from '../../../lib/clsx';

import styles from './Heading2Medium.module.css';

import type { HeadingProps } from './text.types';

export function Heading2Medium(props: HeadingProps) {
  const { lineHeight, color, textAlign, className, style, children, ...rest } = props;

  return (
    <h2
      {...rest}
      className={clsx(styles.root, className)}
      style={{
        '--prop-line-height': lineHeight,
        '--prop-color': color,
        ...style,
      }}
      data-text-align={textAlign}
    >
      {children}
    </h2>
  );
}
